import React, {useMemo} from 'react';
import SourcePackage from '../../../../components/sourcePackage/SourcePackage';
import UnifiedSearchSection from "../../reportEditorPage/leftPanel/components/UnifiedSearchSection";
import DisclosureAIAssistant from './DisclosureAIAssistant';
import {useEditorLeftPanelTabs, useLeftPanelSync} from '../../hooks';
import LeftPanelTabs from '../../components/common/LeftPanelTabs';
import AIAssistantChatTab from '../../components/common/AIAssistantChatTab';
import useSourcesFileViewerStore from '../../../../stores/useSourcesFileViewerStore';

/**
 * Left Panel for Disclosure Editor
 * Simplified version focused on disclosure-specific needs
 * Provides tabs for Search, Source Package, and AI Assistant
 */
const DisclosureLeftPanel = () => {
    const {leftPanelTab, setLeftPanelTab, setAiView} = useLeftPanelSync();
    // Same reverse-portal handoff as report LeftPanel: only one OutPortal may own
    // SourcesSection at a time. Deactivate this host while the file viewer is open
    // so closing Recent Files remounts the Sources list in the disclosure panel.
    const isFileViewerOpen = useSourcesFileViewerStore((state) => state.isOpen);

    const tabs = useMemo(() => ([
        {
            value: 'search',
            label: 'Sources',
            content: (
                <UnifiedSearchSection
                    hostId="disclosure-left-panel-search"
                    isActive={leftPanelTab === 'search' && !isFileViewerOpen}
                />
            ),
        },
        {value: 'sourcePackage', label: 'Source Package', content: <SourcePackage/>},
        {value: 'chat', label: 'Chat', content: <AIAssistantChatTab isActive={leftPanelTab === 'chat'}/>},
        {value: 'aiAssistant', label: 'AI Assistant', content: <DisclosureAIAssistant/>}
    ]), [isFileViewerOpen, leftPanelTab]);

    const {handleTabChange} = useEditorLeftPanelTabs({
        tabs,
        leftPanelTab,
        setLeftPanelTab,
        setAiView,
    });

    return (
        <LeftPanelTabs
            tabs={tabs}
            activeTab={leftPanelTab}
            onChange={handleTabChange}
            ariaLabel="Disclosure left panel tabs"
        />
    );
};

export default DisclosureLeftPanel;
